module.exports = {
    'Init': require('./init'),
    'GetUserAgent': require('./get-user-agent'),
    'DeviceDetection': require('./device-detection'),
    'Throttle': require('./throttle'),
    'Debounce': require('./debounce'),
    'EqualHeights': require('./equal-heights'),
    'ElementAtPointInElement': require('./element-at-point-in-element'),
    'LoadScript': require('./load-script'),
    'GetUrlParameter': require('./get-url-parameter'),
    'Breakpoints': require('./breakpoints'),
    'ProgressBar': require('./progress-bar'),
    'GetCookie': require('./get-cookie'),
    'Consent': require('./consent')
};